import React from 'react';
export default class ViewerErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Error while rendering component viewer:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return React.createElement("p", null, "Something went wrong while rendering this component, please refresh the page.");
        }
        return this.props.children;
    }
}
//# sourceMappingURL=index.js.map